import api from './api'; // Assuming you have an axios instance configured in api.js

/**
 * Sets the Authorization header for all subsequent API requests.
 * @param {string | null} token - The authentication token or null to remove the header.
 */
const setAuthHeader = (token) => {
  if (token) {
    console.log('AuthService: Setting Authorization header');
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    console.log('AuthService: Clearing Authorization header');
    delete api.defaults.headers.common['Authorization'];
  }
};

/**
 * Checks the validity of a token with the backend.
 * @param {string} token - The token to verify.
 * @returns {Promise<{authenticated: boolean}>} - A promise resolving to the authentication status.
 */
const checkAuth = async (token) => {
  try {
    // Temporarily set the header for this check if provided
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    console.log('AuthService: Checking auth status with backend');
    const response = await api.get('/auth/check', { headers });
    console.log('AuthService: Backend check response:', response.data);
    return response.data; // Expected format: { authenticated: true/false }
  } catch (error) {
    console.error('AuthService: Error checking auth with backend:', error.response?.data || error.message);
    return { authenticated: false }; // Assume not authenticated if check fails
  }
};

// Export the functions
const authService = {
  setAuthHeader,
  checkAuth,
};

export default authService; 